import store from '@/store'

/**
 * Middleware to check if user has the correct right to access a certain page.
 * Checks are performed based on route meta fields `meta: { requiresAuth: true }`.
 * @param {object} router Vue router instance
 */
export default function authMiddleware(router) {
    router.beforeEach((to, from, next) => {
        // check for the routes that have `requiresAuth: true`
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!store.getters['auth/token']) {
                return next({ path: '/login' })
            }
            return next()
        }
        return next()
    })
}
